import { Storage } from "@lightningjs/sdk";
import { STORAGE_KEYS } from "./utils";
import configs from "./configs";
import posthog from "./posthog";

// Vodafone invoices per-user off distinct-users-watching-15min, not distinct
// active users, so this only accumulates for whitelisted (Vodafone-IP) users
// on apps that opt in via configs.enableVodafoneWatchTimeMetric.
const THRESHOLD_SECONDS = 15 * 60;

interface WatchTimeBucket {
    date: string;
    seconds: number;
    thresholdFired: boolean;
}

const todayKey = () => new Date().toISOString().slice(0, 10);

const isEnabled = () => {
    const user = Storage.get(STORAGE_KEYS.user);
    return Boolean((configs as any).enableVodafoneWatchTimeMetric) && Boolean(user?.whiteListed);
};

const loadBucket = (): WatchTimeBucket => {
    const stored = Storage.get(STORAGE_KEYS.vodafoneWatchTime) as WatchTimeBucket | undefined;
    const today = todayKey();
    if (stored?.date === today) return stored;
    return { date: today, seconds: 0, thresholdFired: false };
};

export const recordWatchedSeconds = (elapsedSeconds: number) => {
    if (elapsedSeconds <= 0 || !isEnabled()) return;

    const bucket = loadBucket();
    bucket.seconds += elapsedSeconds;

    if (!bucket.thresholdFired && bucket.seconds >= THRESHOLD_SECONDS) {
        bucket.thresholdFired = true;

        try {
            posthog.capture("WatchTime15Min", {
                date: bucket.date,
                isVodafoneUser: true,
                whiteListed: true
            });
        } catch (e) {
            console.error("PostHog error:", e);
        }
    }

    Storage.set(STORAGE_KEYS.vodafoneWatchTime, bucket);
};
